import { useEffect, useState } from 'react';
import type { ChildrenProps } from 'viewup-lib/common';

export const MSWProvider = ({ children }: ChildrenProps) => {
  const [mswReady, setMswReady] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    const init = async () => {
      const initMsw = await import('../../__mocks__/initMSW').then((res) => res.initMsw);
      await initMsw();
      setMswReady(true);
    };

    if (!mswReady) {
      init();
    }
  }, [mswReady]);

  return <>{children}</>;
};
